import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
declare const Swal;

@Component({
  selector: 'g10-request-list',
  templateUrl: './request-list.component.html',
  styleUrls: ['./request-list.component.css']
})
export class RequestListComponent implements OnInit {

  public paramType = '';
  public requestType = '';
  public titleName = 'Request List';

  public requestData = [];

  public tableShow: boolean = false;
  public filterTable: boolean = true;
  public noDataFoundEnable: boolean = false;
  public tableData = [];
  public tableCols: any = [
    { key: '#', display: '#' },
    { key: 'title', display: 'Title' },
    { key: 'priority', display: 'Priority' },
    { key: 'whomToShow', display: 'Request from', config: { isUserImage: true, },headerConfig:{ isDefault: true} },
    { key: 'requestTo', display: 'Request to', config: { isUserImage: true, },headerConfig:{ isDefault: true} },
    {
      key: 'action',
      display: 'Action',
      config: {
        isAction: true,
        actions: [
          { display: 'View', color: 'primary', icon: 'View' },
          { display: 'Update', color: 'primary', icon: 'Edit',class: 'fs-13' },
          { display: 'Delete', color: 'warn', icon: 'Delete' }
        ]
      }
    }
  ];

  public initialTableColConfig: boolean = true;


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private api: ApiService,
    private storage: StorageService,
    public swal: SweetAlert
  ) {
    this.route.paramMap.subscribe((params: any) => {
      this.paramType = params.params.requestType;
      this.requestType = this.paramType.split('-').join('_');
      this.titleName = this.paramType.split('-').join(' ');
      this.getListRequest();
      // console.log(this.requestType)
    });
  }

  ngOnInit(): void {
    // this.requestType = this.route.snapshot.paramMap.get('requestType');
  }


 

  getListRequest() {
    let obj = {
      requestType: [this.requestType],
    };
    this.api.ListRequest(obj).then((res: any) => {
      this.requestData = res.data[this.requestType];
      this.processTableData(res.data[this.requestType]);
    }).catch((err) => {
      console.log(err);
    });
  }

  processTableData(data) {
    this.tableShow = false;
    this.tableData = [];
    if (Array.isArray(data) && data.length > 0) {
      for (let d = 0; d < data.length; d++) {
        let item = data[d];
        let obj = {
          title: item.title ? item.title : '',
          priority: item.priority ? item.priority : 'low',
          requestID: item.requestID,
          whomToShow: item.whomToShow ? item.whomToShow : [],
          requestTo: item.requestTo ? item.requestTo : [],
          reqStatus: item.reqStatus ? item.reqStatus : 0,
        }
        if (this.requestType == 'custom_request') {
          obj['startDate'] = item.startDate;
        }
        this.tableData.push(obj);
      }
      if (this.requestType == 'custom_request' && this.initialTableColConfig) {
        let action = this.tableCols.pop();
        let startDateObj = { key: 'startDate', display: 'Start Date', config: { isDate: true, format: 'dd MMM YYYY' } };
        this.tableCols.push(startDateObj);
        this.tableCols.push(action);
        this.initialTableColConfig = false;
      }
    }
    setTimeout(() => { this.noDataFoundEnable = true; this.tableShow = true; }, 200);
  }

  onActionHandler(e: any) {
    if (e && e.action.display == 'View') {
      this.router.navigate(['/organization/transport-manager/request/list-request', this.paramType, e.data.requestID])
    }
    if (e && e.action.display == 'Update') {
      this.router.navigate(['/organization/transport-manager/request/edit-request', this.paramType, e.data.requestID]);
    }
    if (e && e.action.display == 'Delete') {
      let reqID = e.data.requestID;
      console.log(reqID);
      this.delete(reqID);
    }
  }


  delete(id) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        console.log('delete click');
        this.deleteRequest(id);

      }
    });
  }
  deleteRequest(id) {
    let obj = {
      requestID: id,
    };
    console.log(obj);
    this.api.DeleteRequest(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
        this.noDataFoundEnable = false;
        this.tableShow = false;
        this.getListRequest();
      }
      if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 3000);
      }
    }).catch((err) => {
      console.log(err);
    });
  }

}
